import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import classes from "classnames";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import StarRatingComponent from "Library/react-star-rating-component";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { instance } from "../../../../Actions/AxiosInstance";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
} from "../../../../Utils/Validation";
import { CustomForm } from "../../../../Assets/Js/CustomForm";
import createstore from "../../../../store";

class EmpLanguageForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      isdefault: false,
      fields: {
        branchname: "",
        accountholdername: "",
        accountnumber: "",
        ifsccode: "",
      },
      reqFields: {
        branchname: "",
        accountholdername: "",
        accountnumber: "",
        ifsccode: "",
      },
      list: {
        banknameid: "",
        accounttype: "",
      },
      reqList: {
        banknameid: "",
        accounttype: "",
      },
      errors: {},
      helperText: {},
      languages: [],
      accounttypes: [],
      isRequestSent: false,
      speak: false,
      read: false,
      write: false,
      fluency: [],
    };
  }

  componentDidMount() {
    // CustomForm();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const { employeeid } = SubscriptionInfo.SubscriptionData;
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
      },
      () => {},
    );
  }

  GetPerticularBankDetails() {
    if (this.state.data) {
      const { data } = this.state;
      const { isdefault } = data;
      const { employeebankid } = data;
      const fields = {
        branchname: data.branchname,
        accountholdername: data.accountholdername,
        accountnumber: data.accountnumber,
        ifsccode: data.ifsccode,
        isdefault: data.isdefault,
      };
      const reqFields = {
        branchname: data.branchname,
        accountholdername: data.accountholdername,
        accountnumber: data.accountnumber,
        ifsccode: data.ifsccode,
      };
      const list = {
        banknameid: data.banknameid,
        accounttype: data.accounttype,
      };
      const reqList = {
        banknameid: data.banknameid,
        accounttype: data.accounttype,
      };
      // let selectedBankName = this.state.banknames.find(x => x.displayvalue == data.banknameid);
      // let selectedAccountType = this.state.accounttypes.find(x => x.displayvalue == data.accounttype);
      this.setState({
        fields,
        list,
        isdefault,
        employeebankid,
        reqFields,
        reqList,
      });
    }
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields }, () => {
      ValidateAction(this.state, field, type);
    });
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  ValidateOnNext(reqField, type) {
    const { errors } = this.state;
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
    this.setState({ errors });
  }

  UpdateSelectedId(name, HtField, selectedItem) {
    const { list } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    this.setState({ list });
    if (name == "banknameid") {
      this.setState({ selectedBankName: selectedItem });
    }
    if (name == "accounttype") {
      this.setState({ selectedAccountType: selectedItem });
    }

    const { reqList } = this.state;
    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      reqList[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
      this.setState({ reqList }, () => {
        this.ValidateEachDropDown(name);
      });
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  UpdateLanguage(e) {
    this.setState({ language: e.target.value });
  }

  Updatefluency(e) {
    this.setState({ fluencyid: e.target.value });
  }

  UpdateLanguageDetails = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  AddSkills() {
    if (false /*! this.Validate() */) {
      this.props.enqueueSnackbar("Please fill all the required fields", { variant: "error" });
    } else {
      let flag;
      // if (!createstore.getState().AuthenticationAction.IsFulfilled || this.state.employeeskillid) {
      //     flag = 3
      // }else{
      //     flag = 2
      // }
      // this.setState({ isbuttonDisabled: true, expanded: true });
      const data = {
        employeeskillid: this.state.employeeskillid,
        skill: this.state.skill,
        rating: this.state.rating,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.state.employeeid,
        });
      }
      const URL = "employee/insertupdateempskill";
      instance
        .post(URL, data)
        .then((result) => {
          this.setState(
            {
              skill: "",
              rating: "",
              defaultmsg: false,
              employeeskillid: "",
              EditPerticularSkill: false,
              isEdit: false,
            },
            this.props.SetFlag(3, true),
            //   () => {
            //     this.props.enqueueSnackbar("added successfully", { variant: "success" });
            //     this.props.UpdateStrength(true);
            //     this.GetSkills();
            //     this.setState({ isbuttonDisabled: false, expanded: false });
            //   }
          );
        })
        .catch((error) => {
          // this.setState({ isbuttonDisabled: false, expanded: false });
          const CommonError = error.response ? error.response.data.error.message : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  AddLanguages() {
    this.setState({ isbuttonDisabled: true });
    if (!this.state.language) {
      this.props.enqueueSnackbar("Please Enter Language", { variant: "error" });
      this.setState({ error: true });
      debugger;
    } else if (!this.state.fluencyid) {
      this.props.enqueueSnackbar("Please Select Fulency", { variant: "error" });
      this.setState({ error: true, isbuttonDisabled: false, isEdit: true });
      debugger;
    } else if (!this.state.read && !this.state.speak && !this.state.write) {
      this.props.enqueueSnackbar("Please select any one options", {
        variant: "error",
      });
      this.setState({ error: true, isbuttonDisabled: false });
      debugger;
    } else {
      const data = {
        employeelanguageid: this.state.employeelanguageid,
        language: this.state.language,
        fluencyid: this.state.fluencyid,
        isread: this.state.read,
        iswrite: this.state.write,
        isspeak: this.state.speak,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.state.employeeid,
        });
      }
      const URL = "employee/insertupdateemplanguage";
      instance
        .post(URL, data)
        .then((result) => {
          this.setState(
            (state, prevState) => ({
              EditPerticularLanguage: false,
              isEdit: false,
              defaultmsg: false,
              language: "",
              fluencyid: "",
              read: false,
              write: false,
              speak: false,
              employeelanguageid: "",
              expanded: false,
            }),
            () => {
              this.props.enqueueSnackbar("added successfully", {
                variant: "success",
              });
              this.GetLanguages();
              this.props.UpdateStrength(true);
              this.setState({ isbuttonDisabled: false });
            },
          );
        })
        .catch((error) => {
          this.setState({ isbuttonDisabled: false });
          const CommonError = error.response ? error.response.data.error.message : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
    this.EditLanguages();
  }

  ChangeIsDefaultState(name, event) {
    let isRequestSent = false;
    if (this.state.employeeskillid && this.state.isdefault == false) {
      event.target.checked == true ? (isRequestSent = true) : (isRequestSent = false);
    }
    this.setState({ [name]: event.target.checked, isRequestSent });
  }

  render() {
    return (
      <div className="emp-from-wrapper imp-dates">
        <div className="form-height">
          <div id="div">
            <div className="custom-form-box profile-language" autoComplete="off">
              <div className="inner-wrapper opaque" tabIndex="0">
                <div className="form-group">
                  <div>
                    <TextField
                      id="language-field"
                      label={
                        <FormattedMessage
                          style
                          id="LbEnterLanguage"
                          defaultMessage="Enter Language"
                        />
                      }
                      margin="dense"
                      variant="outlined"
                      onChange={this.UpdateLanguage.bind(this)}
                      value={this.state.language}
                      inputProps={{ maxLength: 40 }}
                      tabIndex="10"
                    />
                  </div>
                </div>
                <div className="padding-top-15" tabIndex="11">
                  <select
                    className="add-lefe-input"
                    onChange={this.Updatefluency.bind(this)}
                    value={this.state.fluencyid}
                  >
                    {this.state.fluency.map((row, id) => (
                      <option value={row.displayvalue} name={row.displayname}>
                        {row.displayname}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="padding-top-15" tabIndex="11">
                  <select
                    className="add-lefe-input"
                    onChange={this.Updatefluency.bind(this)}
                    value={this.state.fluencyid}
                  >
                    {this.state.fluency.map((row, id) => (
                      <option value={row.displayvalue} name={row.displayname}>
                        {row.displayname}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="padding-top-15" align="left">
                  <FormControlLabel
                    control={
                      <Checkbox
                       id="LbRead"
                        checked={this.state.read}
                        onChange={this.UpdateLanguageDetails("read")}
                        value={this.state.read}
                        classes={{
                          root: classes.root,
                          checked: classes.checked,
                        }}
                        color="primary"
                      />
                    }
                    color="primary"
                    label={<FormattedMessage id="LbRead" defaultMessage="Read" />}
                    tabIndex="12"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="LbSpeak"
                        checked={this.state.speak}
                        onChange={this.UpdateLanguageDetails("speak")}
                        value={this.state.speak}
                        classes={{
                          root: classes.root,
                          checked: classes.checked,
                        }}
                        color="primary"
                      />
                    }
                    color="primary"
                    label={<FormattedMessage id="LbSpeak" defaultMessage="Speak" />}
                    tabIndex="13"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="LbWrite"
                        checked={this.state.write}
                        onChange={this.UpdateLanguageDetails("write")}
                        value={this.state.write}
                        classes={{
                          root: classes.root,
                          checked: classes.checked,
                        }}
                        color="primary"
                      />
                    }
                    color="primary"
                    label={<FormattedMessage id="LbWrite" defaultMessage="Write" />}
                    tabIndex="14"
                  />
                </div>
              </div>

              <div className="upform-footer">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className="form-btn save"
                  onClick={this.AddSkills.bind(this)}
                >
                  <FormattedMessage id="BtSave" defaultMessage="Save" />
                </Button>
                <span className="margin-left-16">
                  <Button
                  id="Cancel"
                    variant="outlined"
                    color="primary"
                    size="large"
                    className={classes.button}
                    onClick={() => this.setState({ flag: 1 })}
                  >
                    <FormattedMessage id="BtCancel" defaultMessage="CANCEL" />
                  </Button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withSnackbar(EmpLanguageForm);
